import { useEffect } from "react";
import styles from "./EnterName.module.scss";
import { Formik } from "formik";

// components
import DataSafetyMessage from "../../components/Messages/DataSafetyMessage";
import InfoMessage from "../../components/Messages/InfoMessage";

// methods
import useResponse from "../../hooks/useResponse";
import ServicesAPI from "../../services/services";
import { enterNameValidation } from "../../validations/user.validation";
import { CustomButton } from "../../components";
import {
  googleEvent_LOJ005,
  googleEvent_LOJ007,
  googleEvent_LOJ008,
  googleEvent_LOJ009,
  googleEvent_LOJ010,
} from "../../lib/google-analytics";
import { googleEvent_LOJ004 } from "../../lib/google-analytics-loan-journey-events";

export default function EnterName() {
  const { handleStep } = useResponse();

  const { enterUserNameEmail } = new ServicesAPI();

  useEffect(() => {
    googleEvent_LOJ004();
  }, []);

  return (
    <div className={`wrapper auto-height ${styles.enterName}`}>
      <Formik
        initialValues={{ email: "" }}
        validationSchema={enterNameValidation}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(true);

          setTimeout(async () => {
            const res = await enterUserNameEmail(values.email);

            if (res) {
              handleStep();

              // Events
              googleEvent_LOJ005(values.name, values.email);
            }

            setSubmitting(false);
          }, 500);
        }}
      >
        {({ errors, values, touched, isSubmitting, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
          <form onSubmit={handleSubmit} style={{ height: "100%" }}>
            <div className="vertical-column-layout">
              <div className="vertical-column-top mt-3">
                <h2>
                  Share your email to get <br /> loan documents and updates
                </h2>

                {/* <p className="label">Enter your name</p>
                <div className="sub-label mb-2">
                  Please enter your name as per <strong>PAN</strong>
                </div> */}

                {/* <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your name as per PAN"
                    name="name"
                    value={values.name}
                    onChange={(e) => {
                      setFieldValue("name", e.target.value);
                      if (e.target.value.length === 0) {
                        googleEvent_LOJ007();
                      }
                    }}
                    onBlur={(e) => {
                      setFieldValue("name", e.target.value.trim());
                    }}
                    autoComplete="off"
                  />

                  {touched.name && errors.name ? (
                    <>
                      <div className="error-msg">{errors.name}</div>
                      {googleEvent_LOJ010("name")}
                    </>
                  ) : null}
                </div> */}

                {/* <InfoMessage message="Please enter your correct name as per PAN" /> */}

                <div className="mt-3">
                  <p className="label">Enter your e-mail</p>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter your e-mail"
                      name="email"
                      value={values.email}
                      onChange={(e) => {
                        const email = e.target.value;
                        setFieldValue("email", email);

                        if (email.length === 0) {
                          googleEvent_LOJ009();
                        }

                        const domain = email.includes("@") ? email.split("@")[1] : "";
                        if (domain) {
                          googleEvent_LOJ008(email);
                        }
                      }}
                      onInput={(e) => {
                        setFieldValue("email", e.target.value);
                      }}
                      onBlur={(e) => {
                        setFieldValue("email", e.target.value.trim());
                      }}
                      autoComplete="off"
                    />
                    {touched.email && errors.email ? (
                      <>
                        <div className="error-msg">{errors.email}</div>
                        {googleEvent_LOJ010("email")}
                      </>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="vertical-column-bottom">
                <DataSafetyMessage />
                <CustomButton text="Next" type="submit" />
              </div>
            </div>

          </form>
        )}
      </Formik>
    </div>
  );
}
